import moment from 'moment'

export const DateConstants = {

  YYYY_MM_DD: 'YYYY-MM-DD',
  DD_MM_YYYY: 'DD/MM/YYYY',
  DD_MM_YYYY_HH_MM: 'DD/MM/YYYY HH:mm'

}

export const DateUtils = {

  create: date => {
    return moment(date)
  },

  createFromMillis: millis => {
    return moment.utc(millis)
  },

  parse: (dateString, pattern) => {
    return moment(dateString, pattern)
  },

  formatDate: (date, pattern) => {
    if (pattern) {
      return moment(date).format(pattern)
    }
    return moment(date).format('YYYY-MM-DD')
  },

  getDatesInInterval: (startDate, endDate, interval, unit) => {
    const dates = []

    let momentDate = moment(startDate)
    while (!momentDate.isAfter(endDate)) {
      dates.push(momentDate.toDate())
      momentDate.add(interval, unit)
    }

    return dates
  },

  getWeekDay: (date) =>  {
    return moment(date).isoWeekday()
  },

  getDuration: (input, unit) => {
    return moment.duration(input, unit)
  },

  daysAgo (createdAt) {
    let c = createdAt.split(/[- :]/)
    let dataCriacao = new Date(Date.UTC(c[0], c[1] - 1, c[2], c[3], c[4], c[5]))
    let diff = Math.abs(Date.now() - dataCriacao)
    diff = Math.ceil(diff / (1000 * 60 * 60 * 24)) - 1

    if (diff > 1) {
      return diff + ' dias atrás'
    } else if (diff === 1) {
      return 'Ontem'
    } else {
      return 'Hoje'
    }
  },

  getDifference (firstDate, secondDate) {
    return this.create(firstDate).diff(secondDate)
  },

  lastHourFromDay(date) {
    return moment(date).endOf('day')
  }
}

export default DateUtils
